import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import classNames from 'classnames';
import { isMobileDevice } from '../utils/isMobileDevice';
import { NativeSelect } from './nativeSelect';
import { SelectButton } from './selectButton';
import { SelectButtonLabel } from './selectButtonLabel';
import { SelectPopup } from './selectPopup';
import { SelectContainer } from './selectContainer';
import { Option } from './option';
import { getDropdownDirection, EDropdownDirection } from './utils/getDropdownDirection';
import * as styles from './select.css';

var getOptionsFromChildren = function getOptionsFromChildren(children) {
  return React.Children.toArray(children).reduce(function (options, child) {
    if (child.type === Option) {
      return [].concat(_toConsumableArray(options), [{
        value: child.props.value,
        label: React.Children.toArray(child.props.children).join('')
      }]);
    }

    return options;
  }, // tslint:disable-next-line: no-any
  []);
};

export var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "ref", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "nativeSelectRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "selectPopupRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "selectPopupContainerRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "openDrowdown", function () {
      _this.setState({
        opened: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropdown", function () {
      _this.setState({
        opened: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickButton", function () {
      if (isMobileDevice()) {
        _this.nativeSelectRef.current.click();
      } else if (_this.state.opened) {
        _this.closeDropdown();
      } else {
        _this.openDrowdown();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetOptionState", function (index, selected) {
      _this.nativeSelectRef.current.setOptionState(index, selected);

      if (!_this.props.multiple) {
        _this.closeDropdown();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleOptionState", function (index) {
      _this.nativeSelectRef.current.toggleOptionState(index);
    });

    _defineProperty(_assertThisInitialized(_this), "setPopupDirection", function () {
      var direction = getDropdownDirection(_this.ref.current, _this.selectPopupContainerRef.current);
      var upward = direction === EDropdownDirection.Up;

      if (!upward !== !_this.state.upward) {
        _this.setState({
          upward: upward
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "actions", {
      openDropdown: _this.openDrowdown,
      closeDropdown: _this.closeDropdown,
      moveFocus: function moveFocus(delta) {
        return _this.selectPopupRef.current.moveFocusIndex(delta);
      },
      setFocusedOptionState: function setFocusedOptionState(selected) {
        return _this.selectPopupRef.current.setFocusedOptionState(selected);
      },
      toggleFocusedOptionState: function toggleFocusedOptionState() {
        return _this.selectPopupRef.current.toggleFocusedOptionState();
      }
    });

    _this.state = {
      options: getOptionsFromChildren(props.children),
      children: props.children,
      opened: false,
      upward: false
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.opened && !prevState.opened) {
        this.setPopupDirection();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          disabled = _this$props.disabled,
          multiple = _this$props.multiple,
          _this$props$custom = _this$props.custom,
          custom = _this$props$custom === void 0 ? {} : _this$props$custom,
          selectStyles = _this$props.styles;
      var options = this.state.options;
      var invalid = custom.invalid,
          size = custom.size;
      return React.createElement(SelectContainer, _extends({}, this.props, {
        forwardedRef: this.ref,
        className: styles['select'],
        opened: this.state.opened,
        actions: this.actions,
        style: selectStyles
      }), React.createElement(SelectButton, {
        onClick: this.handleClickButton,
        disabled: disabled,
        active: this.state.opened,
        tabIndex: -1,
        invalid: invalid,
        size: size,
        style: selectStyles
      }, React.createElement(SelectButtonLabel, {
        value: value,
        options: options,
        placeholder: this.props.placeholder
      })), React.createElement(SelectPopup, {
        ref: this.selectPopupRef,
        forwardedRef: this.selectPopupContainerRef,
        className: classNames(styles['select-popup'], this.state.upward && styles['upward']),
        opened: this.state.opened,
        multiple: multiple,
        value: value,
        options: options,
        setOptionState: this.handleSetOptionState,
        toggleOptionState: this.handleToggleOptionState
      }), React.createElement(NativeSelect, {
        ref: this.nativeSelectRef,
        multiple: multiple,
        disabled: disabled,
        value: value,
        onChange: this.props.onChange,
        options: options,
        className: classNames(styles['native-select'], isMobileDevice() && styles['mobile'])
      }));
    }
  }]);

  return Select;
}(React.Component);

_defineProperty(Select, "defaultProps", {
  dataMark: 'Select'
});

_defineProperty(Select, "getDerivedStateFromProps", function (_ref, state) {
  var children = _ref.children;

  if (children === state.children) {
    return null;
  }

  return {
    options: getOptionsFromChildren(children),
    children: children
  };
});